function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import i18n from 'invision-core/src/components/i18n/i18n';
import { OFFER_BEHAVIOR_CONSTANTS } from 'invision-core/src/constants/offer.constants';
import { OFFERING_OPTION_STATUSES } from '../../components/shared/constants/offering.option.status.constants';
import CustomerCareKeys from '../../locales/keys';
import { OFFERING_ACTION_TYPE, PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE } from '../../customercare.constants';
import { MENU_ITEMS } from '../../components/customer/dashboard/dbssDashboard/dashboard.constants';
var isActionValid = function isActionValid() {
  var offeringActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var type = arguments.length > 1 ? arguments[1] : undefined;
  return offeringActions.some(function (offeringAction) {
    return offeringAction === type;
  });
};
export function getMoreMenuItems(hasSubscriptionOptions, allowTransitioning, offering, bulkOffer, changeOfferEligibilityRules, canChangePaymentInstrument) {
  var isInGracePeriod = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var showViewOfferDetailsMenuItem = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var pricingPlanThumbnails = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  var isServiceSection = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
  var showEditOfferAdditionalProperties = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  var isPIIDataAccessEnabled = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : true;
  var menuItems = [];
  var manageOfferItems = [];
  var currentOfferEligibilityRules = changeOfferEligibilityRules.find(function (changeOffer) {
    return changeOffer.OfferingInstanceId === offering.OfferingInstanceId;
  });
  var isEligible = offerIsEligible(offering, currentOfferEligibilityRules);
  var hasSomeSuspendedOptions = offering.Options.some(function (option) {
    return option.Status === OFFERING_OPTION_STATUSES.SUSPENDED;
  });
  var hasSomeActiveOptions = offering.Options.some(function (option) {
    return option.Status === OFFERING_OPTION_STATUSES.ACTIVE;
  });
  var hasSomeOffCycleOfferScheduledForSuspension = offering.Options.some(function (option) {
    var _option$OffCycleDetai;
    return option === null || option === void 0 ? void 0 : (_option$OffCycleDetai = option.OffCycleDetail) === null || _option$OffCycleDetai === void 0 ? void 0 : _option$OffCycleDetai.IsScheduledForSuspensionAtRenewal;
  });
  var canPayRenewalEarly = offering.Options.some(function (option) {
    var _option$OffCycleDetai2;
    return option === null || option === void 0 ? void 0 : (_option$OffCycleDetai2 = option.OffCycleDetail) === null || _option$OffCycleDetai2 === void 0 ? void 0 : _option$OffCycleDetai2.CanPayRenewalEarly;
  });
  var ProvidesConsumesPlanTypes = [PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE.PROVIDES, PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE.CONSUMES];
  var hasProvidesConsumesPlans = offering.Options.some(function (option) {
    return pricingPlanThumbnails[option.PricingPlanId] && ProvidesConsumesPlanTypes.includes(pricingPlanThumbnails[option.PricingPlanId].ServiceRelationshipType);
  });
  var offeringActions = offering.AllowedActionTypes;
  if (isPIIDataAccessEnabled && !offering.IsCoolingOff && offering.Status !== OFFERING_OPTION_STATUSES.REMOVED) {
    manageOfferItems.push({
      id: MENU_ITEMS.ADD_ANOTHER_OFFER,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.ADD_ANOTHER_OFFER)
    });
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.REMOVE)) {
    manageOfferItems.push({
      id: hasSubscriptionOptions ? MENU_ITEMS.REMOVE_OFFER : MENU_ITEMS.DISCONNECT_OFFER,
      title: i18n.translate(hasSubscriptionOptions ? CustomerCareKeys.REMOVE_OFFER.REMOVE_OFFER : CustomerCareKeys.DISCONNECT_OFFERS.REMOVE_OFFER)
    });
  }
  if (showEditOfferAdditionalProperties) {
    if (isServiceSection) {
      manageOfferItems.push({
        id: MENU_ITEMS.EDIT_ADDITIONAL_PROPERTIES,
        title: i18n.translate(CustomerCareKeys.EDIT_ADDITIONAL_PROPERTIES)
      });
    } else {
      manageOfferItems.push({
        id: MENU_ITEMS.EDIT_OFFER_ADDITIONAL_PROPERTIES,
        title: i18n.translate(CustomerCareKeys.EDIT_ADDITIONAL_PROPERTIES)
      });
    }
  }
  if (isPIIDataAccessEnabled) {
    manageOfferItems.push({
      id: MENU_ITEMS.EDIT_OFFER,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.EDIT_OFFER)
    });
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.TRANSITION) && allowTransitioning) {
    manageOfferItems.push({
      id: MENU_ITEMS.CHANGE_OFFER,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.CHANGE_OFFER),
      isDisabled: !isEligible || hasSomeSuspendedOptions,
      isLocked: !isEligible || hasSomeSuspendedOptions,
      hasTooltip: !isEligible,
      tooltip: {
        context: !isEligible ? getOfferRulesContext(offering, currentOfferEligibilityRules) : {},
        template: require('./../../components/customer/dashboard/dbssDashboard/offering/eligibility.tooltip.template.html'),
        icon: 'lock',
        zIndex: 2
      }
    });
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.GROUP_SUSPEND)) {
    manageOfferItems.push({
      id: MENU_ITEMS.SUSPEND_OFFER,
      title: i18n.translate(CustomerCareKeys.SUSPEND_OFFER)
    });
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.GROUP_RESUME)) {
    manageOfferItems.push({
      id: MENU_ITEMS.RESUME_OFFER,
      title: i18n.translate(CustomerCareKeys.RESUME_OFFER)
    });
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.OPT_IN)) {
    manageOfferItems.push({
      id: MENU_ITEMS.ENABLE_AUTO_RENEW,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.ENABLE_AUTO_RENEW)
    });
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.OPT_OUT)) {
    manageOfferItems.push({
      id: MENU_ITEMS.DISABLE_AUTO_RENEW,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.DISABLE_AUTO_RENEW)
    });
  }
  if (hasSomeActiveOptions) {
    manageOfferItems.push({
      id: MENU_ITEMS.SUSPEND_SUBSCRIBER_PRODUCT,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.SUSPEND_SUBSCRIBER_PRODUCTS)
    });
  }
  if (hasSomeSuspendedOptions || hasSomeOffCycleOfferScheduledForSuspension) {
    manageOfferItems.push({
      id: MENU_ITEMS.RESUME_SUBSCRIBER_PRODUCT,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.RESUME_SUBSCRIBER_PRODUCTS)
    });
  }
  if (!offering.IsCoolingOff && offering.Status !== OFFERING_OPTION_STATUSES.REMOVED) {
    if (canChangePaymentInstrument) {
      menuItems.push({
        title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.MANAGE_OFFER),
        subitems: manageOfferItems
      }, {
        title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.MANAGE_PAYMENT_INSTRUMENT),
        subitems: [].concat(_toConsumableArray(isPIIDataAccessEnabled ? [{
          id: MENU_ITEMS.EDIT_PAYMENT_INSTRUMENT,
          title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.EDIT_EXISTING)
        }] : []), [{
          id: MENU_ITEMS.CHANGE_PAYMENT_INSTRUMENT,
          title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.CHANGE)
        }], _toConsumableArray(isPIIDataAccessEnabled ? [{
          id: MENU_ITEMS.ADD_PAYMENT_INSTRUMENT,
          title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.ADD_NEW)
        }] : []))
      });
      if (isInGracePeriod) {
        menuItems.push({
          id: MENU_ITEMS.RETRY_PAYMENT,
          title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.RETRY_PAYMENT)
        });
      }
      if (hasProvidesConsumesPlans && (!bulkOffer || !bulkOffer.length)) {
        menuItems.push({
          id: MENU_ITEMS.MANAGE_PLAN_SERVICES,
          title: i18n.translate(CustomerCareKeys.PRODUCT_SERVICE_RELATIONSHIP.MANAGE_PLAN_SERVICES)
        });
      }
    } else {
      if (showViewOfferDetailsMenuItem) {
        manageOfferItems.push({
          id: MENU_ITEMS.VIEW_OFFER_DETAILS,
          title: i18n.translate(CustomerCareKeys.OFFERINGS_PAGE.VIEW_OFFER_DETAILS)
        });
      }
      if (hasProvidesConsumesPlans && (!bulkOffer || !bulkOffer.length)) {
        manageOfferItems.push({
          id: MENU_ITEMS.MANAGE_PLAN_SERVICES,
          title: i18n.translate(CustomerCareKeys.PRODUCT_SERVICE_RELATIONSHIP.MANAGE_PLAN_SERVICES)
        });
      }
      return manageOfferItems;
    }
  }
  if (isActionValid(offeringActions, OFFERING_ACTION_TYPE.RECONNECT)) {
    menuItems.push({
      id: MENU_ITEMS.RECONNECT_OFFER,
      title: i18n.translate(CustomerCareKeys.RECONNECT_OFFER)
    });
  }
  if (canPayRenewalEarly) {
    menuItems.push({
      id: MENU_ITEMS.MAKE_EARLY_RENEWAL_PAYMENT,
      title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.RENEW_PLAN_NOW)
    });
  }
  return menuItems;
}
export function offerIsEligible(offering, currentOfferEligibilityRules) {
  if (!offering.OfferEligibility || offering.OfferEligibility.OfferBehaviorId === OFFER_BEHAVIOR_CONSTANTS.ALLOW_CHANGE_OFFER) {
    return true;
  }
  if (offering.OfferEligibility.OfferBehaviorId === OFFER_BEHAVIOR_CONSTANTS.CHANGE_OFFER_LOCKED) {
    return false;
  }
  if (offering.OfferEligibility.OfferBehaviorId === OFFER_BEHAVIOR_CONSTANTS.SELECT_ELIGIBILITY_RULE && currentOfferEligibilityRules) {
    return currentOfferEligibilityRules.ChangeOfferEligibilityRules.every(function (offerRule) {
      return offerRule.IsEligible;
    });
  }
}
export function getOfferRulesContext(offering, currentOfferEligibilityRules) {
  var context = {
    title: i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.ELIGIBILITY_RULES)
  };
  if (currentOfferEligibilityRules) {
    Object.assign(context, {
      description: currentOfferEligibilityRules.ChangeOfferEligibilityRules[0].Name,
      descriptionList: currentOfferEligibilityRules.ChangeOfferEligibilityRules.map(function (offerRule) {
        return offerRule;
      })
    });
  }
  return context;
}